import Vue from 'vue';
import Cookies from 'js-cookie';

Vue.component('cookiebar', {
    data() {
        return {
            hasCookies: false
        };
    },

    created() {
        this.hasCookies = typeof Cookies.get('CookiesAccepted') != 'undefined';
    },

    methods: {
        acceptCookies() {
            if (!this.hasCookies) {
                Cookies.set('CookiesAccepted', true);
                this.hasCookies = true;
            }
        }
    }
});
